import { TaxReturnTypes } from 'Containers/Result/utils';
import { FRONT_PLANS } from 'Constants/plans';
import { PlansType, ResultType } from 'Types/common';

export const getUpsellingRecommendPlan = (
  plan: PlansType,
  result: ResultType
): string | undefined => {
  if (
    (plan.name === FRONT_PLANS.FULL_PLUS || plan.name === FRONT_PLANS.PRO_PLUS) &&
    result.taxReturnType === TaxReturnTypes.TO_RETURN
  ) {
    return FRONT_PLANS.FULL_PLUS;
  }

  if (result.taxReturnType === TaxReturnTypes.TO_RETURN) {
    const taxReturnResult = Math.abs(result.taxReturnResult);
    if (taxReturnResult <= 299) return FRONT_PLANS.FULL;
    if (taxReturnResult > 299 && taxReturnResult < 1196) return FRONT_PLANS.PRO;
    return FRONT_PLANS.FLEX;
  }
  if (
    result.taxReturnType === TaxReturnTypes.TO_PAY ||
    result.taxReturnType === TaxReturnTypes.EQUAL
  ) {
    return plan.name === FRONT_PLANS.PRO_PLUS ? FRONT_PLANS.PRO_PLUS : FRONT_PLANS.PRO;
  }
  return undefined;
};
